var React = require("react");
var $ = require('jquery');
var Reflux = require('reflux');
var _ = require('underscore');

// Stores
var LanguageStore = require('../stores/language_store');

// Components
var JobItem = require('./job_item');

// Job Area
module.exports = React.createClass({
	
	getInitialState : function(){
		return {
			status : '',
			error : ''
		}
	},
	
	submitForm : function(e){
		e.preventDefault();
		
		var self = this;
		
		var email = $(e.currentTarget).find("input[name='email']").val();
		var categories = [];
		
		$(e.currentTarget).find("input[name='category']").each(function(){
			if($(this).is(':checked')){
				categories.push($(this).val());
			}
		});
		
		console.log('submit', email, categories);
		
		if(categories.length === 0){
			alert("Please select at least one category!");
		} else {
			$.ajax({
				url: 'subscribe/submit',
				type: 'post',
				data : {
					subscription : JSON.stringify({
						email : email.toLowerCase().trim(),
						categories : categories
					})
				},
				error: function(){},
				success: function(res){
					console.log(res);
					
					if(res.status === 'ok'){
						self.setState({ status : 'ok' });
					} else {
						self.setState({ status : 'error', error : res.error });
					}
				}
			});
		}
	},
	
	// Render
  	render: function(){
  		
  		var self = this;
  		var env_info = self.props.env_info;
  		
  		var sorted_categories = _.sortBy(this.props.categories, (c) => {
	  		return c.name.toLowerCase();
  		});
  		
  		var categories = sorted_categories.map(function(c, index){
  			
  			var name = c.name.replace(/&amp;/ig, '&');

		    return (<li>
		    	<input type="checkbox" name="category" value={c.numeric_id} />{name}
		    </li>);
		});
		
		if(!_.isUndefined(env_info.settings.enable_category_groups) && env_info.settings.enable_category_groups){
			if(!_.isUndefined(env_info.settings.category_groups) && env_info.settings.category_groups.length > 0){
				
				categories = [];
				
				var sorted_category_groups = _.sortBy(env_info.settings.category_groups, (item) => {
					return item.name.toLowerCase();
				});
					
				_.each(sorted_category_groups, function(group){
					categories.push(<li style={{marginTop:'10px'}}>
						<b>{group.name}</b>
					</li>);
					
					var sorted_group_categories = _.sortBy(group.categories, (item) => {
						return item.name.toLowerCase();
					});
					    
				    _.each(sorted_group_categories, function(c){
						categories.push(<li>
							<input type="checkbox" name="category" value={c.id} />{c.name}
						</li>)
					});
				});
			}
		}
			
 		
 		var form = (<form onSubmit={self.submitForm}>
	   		<h1><span className="fa fa-envelope-o"></span> {LanguageStore.get('job_board/title/subscribe')}</h1>
	   		<div className="description">{LanguageStore.get('job_board/description/subscribe')}</div>
	   		<ul className="categories">{categories}</ul>
	   		<input type="text" name="email" placeholder="Email address" />
	   		<input type="submit" name="submit" value={LanguageStore.get('job_board/subscribe/form/button')} />
		</form>);
		
		if(self.state.status === 'ok'){
			form = (<form>
				<h1><span className="fa fa-envelope-o"></span> {LanguageStore.get('job_board/subscribe/complete/title')}</h1>
				<div className="description">{LanguageStore.get('job_board/subscribe/complete/message')}</div>
			</form>)
		}
		
		return (
	   		<div className="subscribe-form-container">
	   			{form}
		 	</div>
	 	);
   		
	}
});
